module.exports = __webpack_public_path__ + "static/media/next.476e8883.svg";